const airlines = [

     {"code": "0A", "name": "Amber Air"},
     {"code": "0B", "name": "Blue Air"},
     {"code": "0C", "name": "IBL Aviation"},
     {"code": "0D", "name": "Darwin Airline"},
     {"code": "0J", "name": "Jetclub"},
     {"code": "0V", "name": "Vietnam Air Services Company (VASCO)"},
     {"code": "1A", "name": "Amadeus IT Group S.A."},
     {"code": "1A", "name": "Amadeus IT Group"},
     {"code": "1B", "name": "Sabre travel network Asia-Pacific (ex-Abacus)"},
     {"code": "1B", "name": "Abacus International"},
     {"code": "1C", "name": "Electronic Data Systems"},
     {"code": "1D", "name": "Radixx"},
     {"code": "1E", "name": "Travelsky"},
     {"code": "1E", "name": "Travelsky Technology"},
     {"code": "1F", "name": "Infini travel information, Inc."},
     {"code": "1F", "name": "INFINI Travel Information"},
     {"code": "1G", "name": "Travelport (Galileo core)"},
     {"code": "1G", "name": "Galileo International"},
     {"code": "1H", "name": "Sirena travel"},
     {"code": "1H", "name": "Siren-Travel"},
     {"code": "1I", "name": "Deutsche Rettungsflugwacht"},
     {"code": "1I", "name": "NetJets"},
     {"code": "1I", "name": "Novair"},
     {"code": "1I", "name": "NetJets Europe"},
     {"code": "1I", "name": "Pegasus Hava Tasimaciligi"},
     {"code": "1I", "name": "Sierra Nevada Airlines"},
     {"code": "1I", "name": "Sky Trek International Airlines"},
     {"code": "1J", "name": "Axess international network, Inc."},
     {"code": "1J", "name": "Axess international network, Inc."},
     {"code": "1K", "name": "AIRKIOSK"},
     {"code": "1K", "name": "Southern Cross Distribution"},
     {"code": "1K", "name": "Sutra"},
     {"code": "1L", "name": "Open Skies Consultative Commission"},
     {"code": "1M", "name": "Sirin"},
     {"code": "1M", "name": "JSC Transport Automated Information Systems"},
     {"code": "1N", "name": "Navitaire"},
     {"code": "1P", "name": "Travelport (Worldspan core)"},
     {"code": "1P", "name": "Worldspan"},
     {"code": "1Q", "name": "Sirena"},
     {"code": "1R", "name": "Hainan Phoenix Information Systems"},
     {"code": "1S", "name": "Sabre travel network"},
     {"code": "1S", "name": "Sabre"},
     {"code": "1T", "name": "Hitit Computer Services"},
     {"code": "1T", "name": "Bulgarian Air Charter"},
     {"code": "1U", "name": "Google/ITA"},
     {"code": "1U", "name": "ITA Software"},
     {"code": "1U", "name": "Polyot Sirena"},
     {"code": "1Y", "name": "Electronic Data Systems"},
     {"code": "1Z", "name": "Sabre Pacific"},
     {"code": "2A", "name": "Deutsche Bahn"},
     {"code": "2B", "name": "Albawings"},
     {"code": "2C", "name": "SNCF"},
     {"code": "2D", "name": "Aero VIP"},
     {"code": "2F", "name": "Frontier Flying Service"},
     {"code": "2G", "name": "Cargoitalia"},
     {"code": "2G*", "name": "San Juan Airlines"},
     {"code": "2H", "name": "Thalys"},
     {"code": "2J", "name": "Air Burkina"},
     {"code": "2K", "name": "Aerogal"},
     {"code": "2L", "name": "Helvetic Airways"},
     {"code": "2M", "name": "Moldavian Airlines"},
     {"code": "2N", "name": "NextJet"},
     {"code": "2N", "name": "Yuzhmashavia"},
     {"code": "2O", "name": "Air Salone"},
     {"code": "2P", "name": "Air Philippines"},
     {"code": "2Q", "name": "Air Cargo Carriers"},
     {"code": "2R", "name": "Via Rail Canada"},
     {"code": "2S", "name": "Island Express"},
     {"code": "2S", "name": "Star Equatorial Airlines"},
     {"code": "2S", "name": "Satgur Air Transport"},
     {"code": "2T", "name": "Timbis Air"},
     {"code": "2T", "name": "Haiti Ambassador Airlines"},
     {"code": "2U", "name": "Air Guinee Express"},
     {"code": "2V*", "name": "Amtrak"},
     {"code": "2W", "name": "Welcome Air"},
     {"code": "2Z", "name": "Chang An Airlines"},
     {"code": "3C", "name": "Calima Aviación"},
     {"code": "3C", "name": "RegionsAir"},
     {"code": "3G", "name": "Atlant-Soyuz Airlines"},
     {"code": "3J", "name": "Jubba Airways"},
     {"code": "3J", "name": "Air Alliance"},
     {"code": "3J", "name": "Zip"},
     {"code": "3K", "name": "Jetstar Asia Airways"},
     {"code": "3L", "name": "Intersky"},
     {"code": "3N", "name": "Air Urga"},
     {"code": "3O", "name": "Air Arabia Maroc"},
     {"code": "3P", "name": "Tiara Air"},
     {"code": "3Q", "name": "China Yunnan Airlines"},
     {"code": "3Q", "name": "KC International Airlines"},
     {"code": "3R", "name": "Moskovia Airlines"},
     {"code": "3S", "name": "Aerologic"},
     {"code": "3S", "name": "Air Guyane Express"},
     {"code": "3S*", "name": "Aeroland Airways"},
     {"code": "3T", "name": "Turan Air"},
     {"code": "3U", "name": "Sichuan Airlines"},
     {"code": "3V", "name": "TNT Airways"},
     {"code": "3W", "name": "Euromanx Airways"},
     {"code": "3W*", "name": "Wan Air"},
     {"code": "3X", "name": "Japan Air Commuter"},
     {"code": "4A", "name": "Air Kiribati"},
     {"code": "4B", "name": "Boutique Air"},
     {"code": "4C", "name": "Aires, Aerovías de Integración Regional, S.A."},
     {"code": "4D", "name": "Air Sinai"},
     {"code": "4D", "name": "Air Sinai"},
     {"code": "4F", "name": "Air City"},
     {"code": "4G", "name": "Gazpromavia"},
     {"code": "4G*", "name": "Advance Leasing Company"},
     {"code": "4H", "name": "United Airways"},
     {"code": "4K*", "name": "Askari Aviation"},
     {"code": "4M", "name": "LATAM Argentina"},
     {"code": "4N", "name": "Air North Charter - Canada"},
     {"code": "4O", "name": "Interjet"},
     {"code": "4O", "name": "Interjet"},
     {"code": "4R", "name": "Star East Airline"},
     {"code": "4R", "name": "Hamburg International"},
     {"code": "4S", "name": "Finalair Congo"},
     {"code": "4T", "name": "Belair Airlines"},
     {"code": "4U", "name": "Germanwings"},
     {"code": "4Y", "name": "Airbus Industrie"},
     {"code": "4Y", "name": "Airbus Transport International"},
     {"code": "4Y", "name": "Airbus France"},
     {"code": "4Y", "name": "Eurowings Discover"},
     {"code": "4Y", "name": "Yute Air Alaska"},
     {"code": "4Z", "name": "Airlink"},
     {"code": "5A", "name": "Alpine Air Express"},
     {"code": "5C", "name": "CAL Cargo Air Lines"},
     {"code": "5D", "name": "Aeroméxico Connect"},
     {"code": "5D", "name": "DonbassAero"},
     {"code": "5F", "name": "Arctic Circle Air Service"},
     {"code": "5F", "name": "Fly One"},
     {"code": "5G", "name": "Skyservice Airlines"},
     {"code": "5J", "name": "Cebu Pacific"},
     {"code": "5K", "name": "Hi Fly"},
     {"code": "5L", "name": "AeroSur"},
     {"code": "5M", "name": "Montserrat Airways"},
     {"code": "5M", "name": "Sibaviatrans"},
     {"code": "5N", "name": "Nordavia"},
     {"code": "5O", "name": "Europe Airpost"},
     {"code": "5P", "name": "Small Planet Airlines"},
     {"code": "5V", "name": "Lviv Airlines"},
     {"code": "5W", "name": "Astraeus"},
     {"code": "5X", "name": "United Parcel Service"},
     {"code": "5Y", "name": "Atlas Air"},
     {"code": "5Z", "name": "Airfreight Express"},
     {"code": "5Z", "name": "Bismillah Airlines"},
     {"code": "5Z", "name": "CemAir"},
     {"code": "5Z", "name": "Gonini Air Services"},
     {"code": "6A", "name": "Aviacsa"},
     {"code": "6B", "name": "TUI fly Nordic"},
     {"code": "6E", "name": "IndiGo"},
     {"code": "6G", "name": "Air Wales"},
     {"code": "6H", "name": "Israir"},
     {"code": "6I", "name": "International Business Air"},
     {"code": "6J", "name": "Jubba Airways"},
     {"code": "6J", "name": "Solaseed Air"},
     {"code": "6K", "name": "Asian Spirit"},
     {"code": "6N", "name": "Niger Airlines"},
     {"code": "6N", "name": "Nordic Regional"},
     {"code": "6P", "name": "Club Air"},
     {"code": "6Q", "name": "Slovak Airlines"},
     {"code": "6R", "name": "Alrosa Air Company"},
     {"code": "6U", "name": "Air Cargo Germany"},
     {"code": "6U", "name": "Air Ukraine"},
     {"code": "6V", "name": "Air Vegas"},
     {"code": "6V", "name": "Axis Airways"},
     {"code": "6V", "name": "Mars RK"},
     {"code": "6W", "name": "Saratov Airlines Joint Stock Company"},
     {"code": "6Y", "name": "Smartlynx Airlines"},
     {"code": "6Z", "name": "Ukrainian Cargo Airways"},
     {"code": "7A", "name": "Express Air Cargo"},
     {"code": "7A", "name": "Aztec Worldwide Airlines"},
     {"code": "7A", "name": "Express Air Cargo"},
     {"code": "7B", "name": "Bees Airline"},
     {"code": "7B", "name": "Krasnojarsky Airlines"},
     {"code": "7C", "name": "Coyne Aviation"},
     {"code": "7C", "name": "Jeju Air"},
     {"code": "7E", "name": "Sylt Air GmbH"},
     {"code": "7F", "name": "Canadian North"},
     {"code": "7F", "name": "First Air"},
     {"code": "7G", "name": "Star Flyer"},
     {"code": "7K", "name": "Kogalymavia Air Company"},
     {"code": "7L", "name": "Silk Way West Airlines"},
     {"code": "7L", "name": "Sun D'Or"},
     {"code": "7M", "name": "Mayair"},
     {"code": "7N", "name": "Pawa Dominicana"},
     {"code": "7N", "name": "PAWA Dominicana"},
     {"code": "7O", "name": "Galaxy Air"},
     {"code": "7R", "name": "BRA-Transportes Aéreos"},
     {"code": "7S", "name": "Ryan Air Services"},
     {"code": "7S", "name": "Ryan Air Services"},
     {"code": "7T", "name": "Air Glaciers"},
     {"code": "7T", "name": "Tobruk Air"},
     {"code": "7W", "name": "Windrose Air"},
     {"code": "8A", "name": "Atlas Blue"},
     {"code": "8B", "name": "Caribbean Star Airlines"},
     {"code": "8C", "name": "Air Transport International"},
     {"code": "8C", "name": "Air Horizon"},
     {"code": "8C", "name": "Shanxi Airlines"},
     {"code": "8D", "name": "FitsAir"},
     {"code": "8D", "name": "Servant Air"},
     {"code": "8D*", "name": "Astair"},
     {"code": "8E", "name": "Bering Air"},
     {"code": "8F", "name": "Fischer Air"},
     {"code": "8H", "name": "BH Air"},
     {"code": "8I", "name": "Myway Airlines"},
     {"code": "8J", "name": "Komiinteravia"},
     {"code": "8L", "name": "Cargo Plus Aviation"},
     {"code": "8L", "name": "Redhill Aviation"},
     {"code": "8M", "name": "Maxair"},
     {"code": "8M", "name": "Myanmar Airways International"},
     {"code": "8N", "name": "Barents AirLink"},
     {"code": "8O", "name": "West Coast Air"},
     {"code": "8P", "name": "Pacific Coastal Airlines"},
     {"code": "8Q", "name": "Onur Air"},
     {"code": "8Q", "name": "Princess Air"},
     {"code": "8Q*", "name": "Baker Aviation"},
     {"code": "8S", "name": "Scorpio Aviation"},
     {"code": "8T", "name": "Air Tindi"},
     {"code": "8U", "name": "Afriqiyah Airways"},
     {"code": "8V", "name": "Astral Aviation"},
     {"code": "8V", "name": "Wright Air Service"},
     {"code": "8W", "name": "Fly All Ways"},
     {"code": "8W", "name": "Private Wings Flugcharter"},
     {"code": "8W?", "name": "BAX Global"},
     {"code": "8Y", "name": "Air Burundi"},
     {"code": "8Y", "name": "China Postal Airlines"},
     {"code": "8Z", "name": "Wizz Air Bulgaria"},
     {"code": "9A", "name": "Eagle Express Air Charter"},
     {"code": "9C", "name": "Spring Airlines"},
     {"code": "9E", "name": "Endeavor Air"},
     {"code": "9E", "name": "Pinnacle Airlines"},
     {"code": "9I", "name": "Air India Regional"},
     {"code": "9I", "name": "Helitrans"},
     {"code": "9I", "name": "Thai Sky Airlines"},
     {"code": "9K", "name": "Cape Air"},
     {"code": "9L", "name": "Colgan Air"},
     {"code": "9L", "name": "AirTanker Services"},
     {"code": "9M", "name": "Central Mountain Air"},
     {"code": "9O", "name": "National Airways Cameroon"},
     {"code": "9Q", "name": "PB Air"},
     {"code": "9R", "name": "Phuket Air"},
     {"code": "9T", "name": "Transwest Air"},
     {"code": "9U", "name": "Air Moldova"},
     {"code": "9V", "name": "Vipair Airlines"},
     {"code": "9W", "name": "Jet Airways"},
     {"code": "9Y", "name": "Fly Georgia"},
     {"code": "A0", "name": "Avianca Argentina"},
     {"code": "A2", "name": "Animawings"},
     {"code": "A2", "name": "Astra Airlines"},
     {"code": "A2", "name": "Cielos Airlines"},
     {"code": "A3", "name": "Aegean Airlines"},
     {"code": "A4", "name": "Southern Winds Airlines"},
     {"code": "A5", "name": "Airlinair"},
     {"code": "A5", "name": "Hop!"},
     {"code": "A6", "name": "Air Alps Aviation"},
     {"code": "A6", "name": "Hongtu Airlines"},
     {"code": "A7", "name": "Air Plus Comet"},
     {"code": "A8", "name": "Aerolink Uganda"},
     {"code": "A8", "name": "Benin Golf Air"},
     {"code": "A9", "name": "Georgian Airways"},
     {"code": "AA", "name": "American Airlines"},
     {"code": "AB", "name": "Air Berlin"},
     {"code": "AC", "name": "Air Canada"},
     {"code": "AD", "name": "Air Paradise International"},
     {"code": "AD", "name": "Azul Linhas Aéreas Brasileiras"},
     {"code": "AE", "name": "Air Ceylon"},
     {"code": "AE", "name": "Mandarin Airlines"},
     {"code": "AF", "name": "Air France"},
     {"code": "AG", "name": "Aruba Airlines"},
     {"code": "AH", "name": "Air Algérie"},
     {"code": "AI", "name": "Air India Limited"},
     {"code": "AJ", "name": "Aero Contractors"},
     {"code": "AK", "name": "AirAsia"},
     {"code": "AK", "name": "Air Bridge Carriers"},
     {"code": "AL", "name": "Skywalk Airlines"},
     {"code": "AL", "name": "TransAVIAexport Airlines"},
     {"code": "AM", "name": "Aeroméxico"},
     {"code": "AN", "name": "Ansett Australia"},
     {"code": "AO", "name": "Australian Airlines"},
     {"code": "AP", "name": "AlbaStar"},
     {"code": "AQ", "name": "Aloha Airlines"},
     {"code": "AQ", "name": "MAP-Management and Planung"},
     {"code": "AR", "name": "Aerolíneas Argentinas"},
     {"code": "AS", "name": "Alaska Airlines, Inc."},
     {"code": "AT", "name": "Royal Air Maroc"},
     {"code": "AU", "name": "Austral Líneas Aéreas"},
     {"code": "AV", "name": "Avianca"},
     {"code": "AW", "name": "Africa World Airlines"},
     {"code": "AW", "name": "CHC Airways"},
     {"code": "AW", "name": "Dirgantara Air Service"},
     {"code": "AX", "name": "AmericanConnection[5]"},
     {"code": "AX", "name": "Trans States Airlines"},
     {"code": "AY", "name": "Finnair"},
     {"code": "AZ", "name": "Alitalia"},
     {"code": "B2", "name": "Belavia Belarusian Airlines"},
     {"code": "B3", "name": "Bellview Airlines"},
     {"code": "B4", "name": "BACH Flugbetriebsges"},
     {"code": "B4", "name": "Bankair"},
     {"code": "B5", "name": "Flightline"},
     {"code": "B6", "name": "JetBlue Airways"},
     {"code": "B7", "name": "UNI Air"},
     {"code": "B8", "name": "Eritrean Airlines"},
     {"code": "B9", "name": "Air Bangladesh"},
     {"code": "BA", "name": "British Airways"},
     {"code": "BB", "name": "Seaborne Airlines"},
     {"code": "BC", "name": "Skymark Airlines"},
     {"code": "BD", "name": "BMI"},
     {"code": "BE", "name": "Flybe"},
     {"code": "BF", "name": "Aero-Service"},
     {"code": "BG", "name": "Biman Bangladesh Airlines"},
     {"code": "BH", "name": "Hawkair"},
     {"code": "BI", "name": "Royal Brunei Airlines"},
     {"code": "BJ", "name": "Nouvel Air Tunisie"},
     {"code": "BK", "name": "Potomac Air"},
     {"code": "BL", "name": "Pacific Airlines"},
     {"code": "BM", "name": "Air Sicilia"},
     {"code": "BM", "name": "BMI Regional"},
     {"code": "BN", "name": "Braniff International Airways"},
     {"code": "BN", "name": "Forward Air International Airlines"},
     {"code": "BN", "name": "Horizon Airlines"},
     {"code": "BO", "name": "BB Airways"},
     {"code": "BO", "name": "Bluebird Nordic"},
     {"code": "BO", "name": "Bouraq Indonesia Airlines"},
     {"code": "BP", "name": "Air Botswana"},
     {"code": "BQ", "name": "Aeromar Lineas Aereas Dominicanas"},
     {"code": "BQ", "name": "Baltia Air Lines"},
     {"code": "BR", "name": "EVA Air"},
     {"code": "BS", "name": "British International Helicopters"},
     {"code": "BS", "name": "US-Bangla Airlines"},
     {"code": "BT", "name": "Air Baltic"},
     {"code": "BU", "name": "Buryat Airlines Aircompany"},
     {"code": "BV", "name": "Blue Panorama Airlines"},
     {"code": "BW", "name": "Caribbean Airlines"},
     {"code": "BW", "name": "Caribbean Airlines"},
     {"code": "BX", "name": "Air Busan"},
     {"code": "BX", "name": "Coast Air"},
     {"code": "BY", "name": "TUI Airways"},
     {"code": "BZ", "name": "Blue Dart Aviation"},
     {"code": "BZ", "name": "Keystone Air Service"},
     {"code": "C3", "name": "Independent Carrier (ICAR)"},
     {"code": "C4", "name": "Zimex Aviation"},
     {"code": "C4", "name": "Zimex Aviation"},
     {"code": "C5", "name": "CommutAir"},
     {"code": "C6", "name": "CanJet"},
     {"code": "C7", "name": "Cinnamon Air"},
     {"code": "C7", "name": "Rico Linhas Aéreas"},
     {"code": "C8", "name": "Cargolux Italia"},
     {"code": "C8", "name": "Chicago Jet Group"},
     {"code": "C9", "name": "Cirrus Airlines"},
     {"code": "CA", "name": "Air China"},
     {"code": "CB*", "name": "Kalitta Charters II"},
     {"code": "CC", "name": "Air Atlanta Icelandic"},
     {"code": "CC", "name": "Macair Airlines"},
     {"code": "CD", "name": "Corendon Dutch Airlines"},
     {"code": "CE", "name": "Nationwide Airlines"},
     {"code": "CG", "name": "Airlines PNG"},
     {"code": "CH", "name": "Bemidji Airlines"},
     {"code": "CI", "name": "China Airlines"},
     {"code": "CJ", "name": "BA CityFlyer"},
     {"code": "CJ", "name": "China Northern Airlines"},
     {"code": "CJ", "name": "CityFlyer Express"},
     {"code": "CK", "name": "China Cargo Airlines"},
     {"code": "CL", "name": "Lufthansa CityLine"},
     {"code": "CM", "name": "Copa Airlines"},
     {"code": "CN", "name": "Islands Nationair"},
     {"code": "CN", "name": "Westward Airways"},
     {"code": "CO", "name": "Continental Airlines"},
     {"code": "CO", "name": "Continental Express"},
     {"code": "CP", "name": "Canadian Airlines"},
     {"code": "CP", "name": "Canadian Pacific Airlines"},
     {"code": "CP", "name": "Compass Airlines"},
     {"code": "CQ", "name": "Central Charter"},
     {"code": "CQ", "name": "Sunshine Express Airlines"},
     {"code": "CS", "name": "Continental Micronesia"},
     {"code": "CT", "name": "Civil Air Transport"},
     {"code": "CU", "name": "Cubana de Aviación"},
     {"code": "CV", "name": "Air Chathams"},
     {"code": "CV", "name": "Cargolux"},
     {"code": "CW", "name": "Air Marshall Islands"},
     {"code": "CX", "name": "Cathay Pacific"},
     {"code": "CY", "name": "Cyprus Airways"},
     {"code": "CZ", "name": "China Southern Airlines"},
     {"code": "D0", "name": "DHL Air Limited"},
     {"code": "D2", "name": "Severstal Air Company"},
     {"code": "D3", "name": "Daallo Airlines"},
     {"code": "D4", "name": "Alidaunia"},
     {"code": "D5", "name": "Dauair"},
     {"code": "D6", "name": "Interair South Africa"},
     {"code": "D7", "name": "AirAsia X"},
     {"code": "D7", "name": "FlyAsianXpress"},
     {"code": "D8", "name": "Norwegian Air International (Norway)"},
     {"code": "D8", "name": "Norwegian Air International"},
     {"code": "D9", "name": "Donavia"},
     {"code": "DA", "name": "Air Georgia"},
     {"code": "DB", "name": "Brit Air"},
     {"code": "DB", "name": "Maleth-Aero"},
     {"code": "DC", "name": "Golden Air"},
     {"code": "DD", "name": "Danish Air Lines"},
     {"code": "DD", "name": "Nok Air"},
     {"code": "DE", "name": "Condor Flugdienst"},
     {"code": "DG", "name": "Cebgo"},
     {"code": "DH", "name": "Discovery Airways"},
     {"code": "DH", "name": "Independence Air"},
     {"code": "DH", "name": "Norwegian Air Norway"},
     {"code": "DI", "name": "Dba"},
     {"code": "DI", "name": "Norwegian Air UK"},
     {"code": "DJ", "name": "AirAsia Japan"},
     {"code": "DJ", "name": "Pacific Blue"},
     {"code": "DJ", "name": "Polynesian Blue"},
     {"code": "DK", "name": "Eastland Air"},
     {"code": "DL", "name": "Delta Air Lines"},
     {"code": "DM", "name": "Maersk Air"},
     {"code": "DN", "name": "Norwegian Air Argentina"},
     {"code": "DO", "name": "Dominicana de Aviación"},
     {"code": "DP", "name": "Air 2000"},
     {"code": "DP", "name": "First Choice Airways"},
     {"code": "DQ", "name": "Coastal Air"},
     {"code": "DS", "name": "easyJet Switzerland"},
     {"code": "DT", "name": "TAAG Angola Airlines"},
     {"code": "DU", "name": "Norwegian Long Haul"},
     {"code": "DV", "name": "Nantucket Airlines"},
     {"code": "DV", "name": "Scat Air"},
     {"code": "DW", "name": "Aero-Charter Ukraine"},
     {"code": "DX", "name": "DAT Danish Air Transport"},
     {"code": "DY", "name": "Norwegian Air Shuttle"},
     {"code": "E0", "name": "Eos Airlines"},
     {"code": "E1", "name": "Everbread"},
     {"code": "E2", "name": "Eurowings Europe"},
     {"code": "E2", "name": "Kampuchea Airlines"},
     {"code": "E2", "name": "Rio Grande Air"},
     {"code": "E3", "name": "Domodedovo Airlines"},
     {"code": "E3", "name": "Sabaidee Airways"},
     {"code": "E4", "name": "Aero Asia International"},
     {"code": "E5", "name": "Samara Airlines"},
     {"code": "E5", "name": "Air Arabia Egypt"},
     {"code": "E6", "name": "Bringer Air Cargo Taxi Aéreo"},
     {"code": "E7", "name": "Estafeta Carga Aérea"},
     {"code": "E7", "name": "European Aviation Air Charter"},
     {"code": "E8", "name": "Alpi Eagles"},
     {"code": "E9", "name": "Boston-Maine Airways"},
     {"code": "EA", "name": "Eastern Air Lines"},
     {"code": "EA", "name": "Emerald Airlines"},
     {"code": "EA", "name": "European Air Express"},
     {"code": "EC", "name": "Avialeasing Aviation Company"},
     {"code": "EC", "name": "easyJet Europe"},
     {"code": "ED*", "name": "Airblue"},
     {"code": "EE", "name": "Aero Airlines"},
     {"code": "EG", "name": "Japan Asia Airways"},
     {"code": "EH", "name": "Air Nippon Network Co. Ltd."},
     {"code": "EH", "name": "SAETA"},
     {"code": "EI", "name": "Aer Lingus"},
     {"code": "EJ", "name": "New England Airlines"},
     {"code": "EK", "name": "Emirates Airlines"},
     {"code": "EL", "name": "Air Nippon"},
     {"code": "EL", "name": "Ellinair"},
     {"code": "EM", "name": "Empire Airlines"},
     {"code": "EM*", "name": "Aero Benin"},
     {"code": "EN", "name": "Air Dolomiti"},
     {"code": "EO", "name": "Express One International"},
     {"code": "EO", "name": "Hewa Bora Airways"},
     {"code": "EP", "name": "Iran Aseman Airlines"},
     {"code": "EQ", "name": "TAME"},
     {"code": "ER", "name": "Astar Air Cargo"},
     {"code": "ES", "name": "DHL International"},
     {"code": "ET", "name": "Ethiopian Airlines"},
     {"code": "EU", "name": "Empresa Ecuatoriana De Aviación"},
     {"code": "EV", "name": "Atlantic Southeast Airlines"},
     {"code": "EV", "name": "ExpressJet"},
     {"code": "EVY", "name": "34 Squadron, Royal Australian Air Force"},
     {"code": "EW", "name": "Eurowings"},
     {"code": "EX", "name": "Atlantic Airlines"},
     {"code": "EX", "name": "Air Santo Domingo"},
     {"code": "EY", "name": "Etihad Airways"},
     {"code": "EZ", "name": "Evergreen International Airlines"},
     {"code": "EZ", "name": "Sun Air of Scandinavia"},
     {"code": "F2", "name": "Fly Air"},
     {"code": "F3", "name": "Faso Airways"},
     {"code": "F4", "name": "Albarka Air"},
     {"code": "F5", "name": "Cosmic Air"},
     {"code": "F6", "name": "FaroeJet"},
     {"code": "F7", "name": "Flybaboo"},
     {"code": "F9", "name": "Frontier Airlines"},
     {"code": "FA", "name": "Safair"},
     {"code": "FB", "name": "Bulgaria Air"},
     {"code": "FC", "name": "Finncomm Airlines"},
     {"code": "FD", "name": "Royal Flying Doctor Service"},
     {"code": "FD", "name": "Thai AirAsia"},
     {"code": "FE", "name": "Far Eastern Air Transport"},
     {"code": "FE", "name": "Primaris Airlines"},
     {"code": "FF", "name": "Airshop"},
     {"code": "FG", "name": "Ariana Afghan Airlines"},
     {"code": "FH", "name": "Freebird Airlines"},
     {"code": "FH", "name": "Futura International Airways"},
     {"code": "FI", "name": "Icelandair"},
     {"code": "FJ", "name": "Fiji Airways"},
     {"code": "FK", "name": "Africa West"},
     {"code": "FK", "name": "Keewatin Air"},
     {"code": "FL", "name": "Air Leap"},
     {"code": "FL", "name": "AirTran Airways"},
     {"code": "FM", "name": "Shanghai Airlines"},
     {"code": "FN", "name": "Regional Air Lines"},
     {"code": "FO", "name": "Airlines of Tasmania"},
     {"code": "FO", "name": "Flybondi"},
     {"code": "FP", "name": "FlyPelican"},
     {"code": "FP", "name": "Freedom Air"},
     {"code": "FP", "name": "Servicios Aéreos de los Andes"},
     {"code": "FR", "name": "Ryanair"},
     {"code": "FS", "name": "Flyr"},
     {"code": "FS", "name": "Itali Airlines"},
     {"code": "FS", "name": "Servicios de Transportes Aéreos Fueguinos"},
     {"code": "FT", "name": "FlyEgypt"},
     {"code": "FT", "name": "Siem Reap Airways"},
     {"code": "FV", "name": "Pulkovo Aviation Enterprise"},
     {"code": "FV", "name": "Rossiya"},
     {"code": "FW", "name": "Ibex Airlines"},
     {"code": "FX", "name": "FedEx Express"},
     {"code": "FY", "name": "Firefly"},
     {"code": "FY", "name": "Northwest Regional Airlines"},
     {"code": "FZ", "name": "Flydubai"},
     {"code": "G0", "name": "Ghana International Airlines"},
     {"code": "G1", "name": "Gorkha Airlines"},
     {"code": "G2", "name": "Avirex"},
     {"code": "G3", "name": "City Connexion Airlines"},
     {"code": "G3", "name": "Gol Transportes Aéreos"},
     {"code": "G4", "name": "Allegiant Air"},
     {"code": "G5", "name": "China Express Airlines"},
     {"code": "G6", "name": "Guine Bissaur Airlines"},
     {"code": "G6", "name": "Air Volga"},
     {"code": "G7", "name": "Gandalf Airlines"},
     {"code": "G7", "name": "GoJet Airlines"},
     {"code": "G8", "name": "Air Service Gabon"},
     {"code": "G8", "name": "Enkor JSC"},
     {"code": "G8", "name": "GoAir"},
     {"code": "G8", "name": "Gujarat Airways"},
     {"code": "G9", "name": "Air Arabia"},
     {"code": "GA", "name": "Garuda Indonesia"},
     {"code": "GB", "name": "Airborne Express"},
     {"code": "GB", "name": "ABX Air"},
     {"code": "GC", "name": "Gambia International Airlines"},
     {"code": "GD", "name": "Air Alpha Greenland"},
     {"code": "GE", "name": "TransAsia Airways"},
     {"code": "GF", "name": "Gulf Air"},
     {"code": "GG", "name": "Air Guyane"},
     {"code": "GG", "name": "Air Comores International"},
     {"code": "GG", "name": "Cargo 360"},
     {"code": "GG", "name": "Sky Lease Cargo"},
     {"code": "GH", "name": "Globus Airlines"},
     {"code": "GH", "name": "Ghana Airways"},
     {"code": "GI", "name": "Itek Air"},
     {"code": "GJ", "name": "Compania Mexicargo"},
     {"code": "GJ", "name": "CDI Cargo Airlines"},
     {"code": "GJ", "name": "Eurofly"},
     {"code": "GK", "name": "Go One Airways"},
     {"code": "GK", "name": "Jetstar Japan"},
     {"code": "GL", "name": "Air Greenland"},
     {"code": "GL", "name": "Air Greenland"},
     {"code": "", "name": ""},
     {"code": "GM", "name": "Air Slovakia"},
     {"code": "GN", "name": "Air Gabon"},
     {"code": "GO", "name": "Kuzu Airlines Cargo"},
     {"code": "GP", "name": "APG Airlines"},
     {"code": "GP", "name": "Palau Trans Pacific Airlines"},
     {"code": "GQ", "name": "Big Sky Airlines"},
     {"code": "GR", "name": "Aurigny Air Services"},
     {"code": "GR", "name": "Gemini Air Cargo"},
     {"code": "GS", "name": "Air Foyle"},
     {"code": "GS", "name": "Tianjin Airlines"},
     {"code": "GT", "name": "GB Airways"},
     {"code": "GV", "name": "Aero Flight"},
     {"code": "GV", "name": "Grant Aviation"},
     {"code": "GW", "name": "Costa Rica Green Airways"},
     {"code": "GW", "name": "Kuban Airlines"},
     {"code": "GW", "name": "SkyGreece Airlines"},
     {"code": "GX", "name": "Guangxi Beibu Gulf Airlines"},
     {"code": "GX", "name": "JetX Airlines"},
     {"code": "GX", "name": "Pacificair"},
     {"code": "GY", "name": "Guyana Airways 2000"},
     {"code": "GY", "name": "Tri-MG Intra Asia Airlines"},
     {"code": "GZ", "name": "Air Rarotonga"},
     {"code": "H1", "name": "Hahn Air Systems"},
     {"code": "H1", "name": "Hooters Air"},
     {"code": "H2", "name": "Sky Airline"},
     {"code": "H4", "name": "Héli Sécurité Helicopter Airlines"},
     {"code": "H4", "name": "Inter Island Airways"},
     {"code": "H5", "name": "Hola Airlines"},
     {"code": "H5", "name": "Mavial Magadan Airlines"},
     {"code": "H6", "name": "Hageland Aviation Services"},
     {"code": "H7", "name": "Eagle Air"},
     {"code": "H8", "name": "Dalavia"},
     {"code": "H9", "name": "Air d'Ayiti"},
     {"code": "H9", "name": "Himalaya Airlines"},
     {"code": "H9", "name": "Izair"},
     {"code": "HA", "name": "Hawaiian Airlines"},
     {"code": "HB", "name": "Harbor Airlines"},
     {"code": "HC", "name": "Aero-Tropics Air Services"},
     {"code": "HC", "name": "Air Senegal"},
     {"code": "HC", "name": "Holidays Czech Airlines"},
     {"code": "HC", "name": "Iceland Express"},
     {"code": "HD", "name": "Air Holland"},
     {"code": "HD", "name": "AIRDO"},
     {"code": "HE", "name": "German Airways"},
     {"code": "HF", "name": "Hapagfly"},
     {"code": "HG", "name": "Niki"},
     {"code": "HH", "name": "Hope Air"},
     {"code": "HJ", "name": "Asian Express Airlines"},
     {"code": "HJ", "name": "Hellas Jet"},
     {"code": "HK", "name": "Four Star Aviation / Four Star Cargo"},
     {"code": "HM", "name": "Air Seychelles"},
     {"code": "HN", "name": "Heavylift Cargo Airlines"},
     {"code": "HO", "name": "Antinea Airlines"},
     {"code": "HO", "name": "Juneyao Airlines"},
     {"code": "HP", "name": "America West Airlines"},
     {"code": "HP", "name": "Hawaiian Pacific Airlines"},
     {"code": "HP", "name": "Pearl Airways"},
     {"code": "HP", "name": "Phoenix Airways"},
     {"code": "HQ", "name": "Harmony Airways"},
     {"code": "HQ", "name": "Thomas Cook Airlines"},
     {"code": "HR", "name": "Hahn Air"},
     {"code": "HT", "name": "Aeromist-Kharkiv"},
     {"code": "HU", "name": "Hainan Airlines"},
     {"code": "HV", "name": "Transavia Holland"},
     {"code": "HW", "name": "Hello"},
     {"code": "HW", "name": "North-Wright Airways"},
     {"code": "HX", "name": "Hong Kong Airlines"},
     {"code": "HY", "name": "Uzbekistan Airways"},
     {"code": "HZ", "name": "Sakhalinskie Aviatrassy (SAT)"},
     {"code": "HZ", "name": "Sat Airlines"},
     {"code": "I2", "name": "Iberia Express"},
     {"code": "I4", "name": "Island Air Express"},
     {"code": "I4", "name": "Interstate Airlines"},
     {"code": "I5", "name": "AirAsia India"},
     {"code": "I6", "name": "Sky Eyes"},
     {"code": "I7", "name": "Paramount Airways"},
     {"code": "I9", "name": "Indigo Airlines"},
     {"code": "IA", "name": "Iraqi Airways"},
     {"code": "IB", "name": "Iberia Airlines"},
     {"code": "IC", "name": "Indian Airlines"},
     {"code": "ID", "name": "Batik Air"},
     {"code": "ID", "name": "Interlink Airlines"},
     {"code": "IE", "name": "Solomon Airlines"},
     {"code": "IF", "name": "Islas Airways"},
     {"code": "IG", "name": "Air Italy"},
     {"code": "IG", "name": "Meridiana"},
     {"code": "IH", "name": "Falcon Aviation"},
     {"code": "IH", "name": "Irtysh Air"},
     {"code": "II", "name": "IBC Airways"},
     {"code": "IJ", "name": "Great Wall Airlines"},
     {"code": "IJ", "name": "Spring Airlines Japan"},
     {"code": "IK", "name": "Ikar"},
     {"code": "IK", "name": "Lankair"},
     {"code": "IM", "name": "Menajet"},
     {"code": "IN", "name": "MAT Macedonian Airlines"},
     {"code": "IN", "name": "NAM Air"},
     {"code": "IO", "name": "Indonesian Airlines"},
     {"code": "IP", "name": "Atyrau Air Ways"},
     {"code": "IP", "name": "One Airlines"},
     {"code": "IQ", "name": "Augsburg Airways"},
     {"code": "IR", "name": "Iran Air"},
     {"code": "IRK", "name": "KISHAIR"},
     {"code": "IT", "name": "Kingfisher Airlines"},
     {"code": "IT", "name": "Tigerair Taiwan"},
     {"code": "IV", "name": "Wind Jet"},
     {"code": "IW", "name": "AOM French Airlines"},
     {"code": "IW", "name": "Wings Air"},
     {"code": "IX", "name": "Air India Express"},
     {"code": "IY", "name": "Yemenia"},
     {"code": "IZ", "name": "Arkia Israel Airlines"},
     {"code": "J2", "name": "Azerbaijan Airlines"},
     {"code": "J3", "name": "Northwestern Air"},
     {"code": "J4", "name": "Buffalo Airways"},
     {"code": "J4", "name": "Jordan International Air Cargo"},
     {"code": "J6", "name": "AVCOM"},
     {"code": "J7", "name": "Centre-Avia"},
     {"code": "J7", "name": "Denim Air"},
     {"code": "J7", "name": "ValuJet Airlines"},
     {"code": "J8", "name": "Berjaya Air"},
     {"code": "J9", "name": "Guinee Airlines"},
     {"code": "J9", "name": "Jazeera Airways"},
     {"code": "JA", "name": "B&H Airlines"},
     {"code": "JA", "name": "JetSMART"},
     {"code": "JB", "name": "Helijet"},
     {"code": "JC", "name": "JAL Express"},
     {"code": "JD", "name": "Beijing Capital Airlines"},
     {"code": "JE", "name": "Mango"},
     {"code": "JF", "name": "Jet Asia Airways"},
     {"code": "JF", "name": "L.A.B. Flying Service"},
     {"code": "JH", "name": "Fuji Dream Airlines"},
     {"code": "JH", "name": "Nordeste Linhas Aéreas Regionais"},
     {"code": "JI", "name": "Jade Cargo International"},
     {"code": "JI", "name": "Midway Airlines (1993–2003)"},
     {"code": "JJ", "name": "Aviogenex"},
     {"code": "JJ", "name": "LATAM Brasil"},
     {"code": "JK", "name": "Spanair"},
     {"code": "JL", "name": "Japan Airlines"},
     {"code": "JL", "name": "Japan Airlines Domestic"},
     {"code": "JM", "name": "Air Jamaica"},
     {"code": "JM", "name": "Jetstar Hong Kong Airways"},
     {"code": "JN", "name": "Excel Airways"},
     {"code": "JO", "name": "JALways"},
     {"code": "JO", "name": "Jettime"},
     {"code": "JP", "name": "Adria Airways"},
     {"code": "JQ", "name": "Jetstar"},
     {"code": "JR", "name": "Aero California"},
     {"code": "JS", "name": "Air Koryo"},
     {"code": "JT", "name": "Lion Air"},
     {"code": "JU", "name": "Air Serbia"},
     {"code": "JV", "name": "Bearskin Lake Air Service"},
     {"code": "JW", "name": "Arrow Air"},
     {"code": "JW", "name": "Vanilla Air"},
     {"code": "JX", "name": "Jett8 Airlines Cargo"},
     {"code": "JX", "name": "Starlux Airlines"},
     {"code": "JY", "name": "InterCaribbean Airways"},
     {"code": "JY", "name": "Air Turks and Caicos"},
     {"code": "JZ", "name": "Avia Express"},
     {"code": "JZ", "name": "Skyways Express"},
     {"code": "K2", "name": "Eurolot"},
     {"code": "K3", "name": "Taquan Air Services"},
     {"code": "K4", "name": "Kalitta Air"},
     {"code": "K5", "name": "SeaPort Airlines"},
     {"code": "K6", "name": "Angkor Air"},
     {"code": "K6", "name": "Cambodia Angkor Air"},
     {"code": "K6", "name": "Khalifa Airways"},
     {"code": "K8", "name": "Airlink Zambia"},
     {"code": "K9", "name": "Kalitta Charters"},
     {"code": "K9", "name": "Krylo Airlines"},
     {"code": "KA", "name": "Cathay Dragon"},
     {"code": "KB", "name": "Druk Air"},
     {"code": "KC", "name": "Air Astana"},
     {"code": "KC", "name": "Air Astana"},
     {"code": "KD", "name": "Air Enterprise"},
     {"code": "KD", "name": "Kalstar Aviation"},
     {"code": "KD", "name": "KD Avia"},
     {"code": "KE", "name": "Korean Air"},
     {"code": "KF", "name": "Blue1"},
     {"code": "KG", "name": "LAI - Línea Aérea IAACA"},
     {"code": "KH", "name": "Aloha Air Cargo"},
     {"code": "KI", "name": "Air Atlantique"},
     {"code": "KI", "name": "Adam Air"},
     {"code": "KI", "name": "KaiserAir"},
     {"code": "KJ", "name": "Asian Air"},
     {"code": "KJ", "name": "British Mediterranean Airways"},
     {"code": "KK", "name": "Atlasjet"},
     {"code": "KL", "name": "KLM"},
     {"code": "KM", "name": "Air Malta"},
     {"code": "KN", "name": "China United Airlines"},
     {"code": "KO", "name": "Alaska Central Express"},
     {"code": "KP", "name": "Kiwi International Air Lines"},
     {"code": "KQ", "name": "Kenya Airways"},
     {"code": "KR", "name": "Cambodia Airways"},
     {"code": "KR", "name": "Comores Airlines"},
     {"code": "KS", "name": "Peninsula Airways"},
     {"code": "KU", "name": "Kuwait Airways"},
     {"code": "KV", "name": "Kavminvodyavia"},
     {"code": "KV", "name": "Sky Regional Airlines"},
     {"code": "KW", "name": "Kharkiv Airlines"},
     {"code": "KW", "name": "Kelowna Flightcraft Air Charter"},
     {"code": "KW", "name": "Wataniya Airways"},
     {"code": "KX", "name": "Cayman Airways"},
     {"code": "KY", "name": "Air São Tomé and Príncipe"},
     {"code": "KZ", "name": "Nippon Cargo Airlines"},
     {"code": "L1", "name": "Lufthansa Systems"},
     {"code": "L2", "name": "Lynden Air Cargo"},
     {"code": "L3", "name": "DHL de Guatemala"},
     {"code": "L3", "name": "LTU Austria"},
     {"code": "L4", "name": "Lynx Aviation"},
     {"code": "L5", "name": "Línea Aérea Cuencana"},
     {"code": "L5", "name": "Lufttransport"},
     {"code": "L6", "name": "Tbilaviamsheni"},
     {"code": "L7", "name": "Laoag International Airlines"},
     {"code": "L7", "name": "Línea Aérea SAPSA"},
     {"code": "L8", "name": "Air Luxor GB"},
     {"code": "L9", "name": "Air Mali"},
     {"code": "L9", "name": "Belle Air Europe"},
     {"code": "L9", "name": "Bristow U.S. LLC"},
     {"code": "L9", "name": "Teamline Air"},
     {"code": "LA", "name": "LATAM Chile"},
     {"code": "LB", "name": "Lloyd Aéreo Boliviano"},
     {"code": "LC", "name": "Varig Logística"},
     {"code": "LD", "name": "Air Hong Kong"},
     {"code": "LE", "name": "Norwegian Air Sweden"},
     {"code": "LF", "name": "Contour Airlines"},
     {"code": "LF", "name": "FlyNordic"},
     {"code": "LG", "name": "Luxair"},
     {"code": "LH", "name": "Lufthansa"},
     {"code": "LH", "name": "Lufthansa Cargo"},
     {"code": "LI", "name": "Leeward Islands Air Transport"},
     {"code": "LJ", "name": "Jin Air"},
     {"code": "LJ", "name": "Sierra National Airlines"},
     {"code": "LK", "name": "Air Luxor"},
     {"code": "LL", "name": "Allegro"},
     {"code": "LL", "name": "Miami Air International"},
     {"code": "LM", "name": "Livingston Energy Flight"},
     {"code": "LM", "name": "Loganair"},
     {"code": "LN", "name": "Libyan Arab Airlines"},
     {"code": "LO", "name": "LOT Polish Airlines"},
     {"code": "LP", "name": "LATAM Peru"},
     {"code": "LQ", "name": "Lebanese Air Transport"},
     {"code": "LR", "name": "LACSA"},
     {"code": "LS", "name": "Jet2.com"},
     {"code": "LS", "name": "Jet2"},
     {"code": "LT", "name": "LTU International"},
     {"code": "LT", "name": "LongJiang Airlines"},
     {"code": "LU", "name": "LATAM Express"},
     {"code": "LV", "name": "Albanian Airlines"},
     {"code": "LV", "name": "Level"},
     {"code": "LW", "name": "Pacific Wings"},
     {"code": "LW", "name": "Sun Air International"},
     {"code": "LX", "name": "Swiss International Air Lines"},
     {"code": "LY", "name": "El Al Israel Airlines"},
     {"code": "LZ", "name": "Balkan Bulgarian Airlines"},
     {"code": "LZ[52]", "name": "Swiss Global Air Lines"},
     {"code": "M2", "name": "Mahfooz Aviation"},
     {"code": "M2", "name": "MHS Aviation GmbH"},
     {"code": "M3", "name": "ABSA Cargo"},
     {"code": "M3", "name": "Air Service"},
     {"code": "M3", "name": "North Flying"},
     {"code": "M4", "name": "Mistral Air"},
     {"code": "M4", "name": "Poste Air Cargo"},
     {"code": "M5", "name": "Kenmore Air"},
     {"code": "M6", "name": "Amerijet International"},
     {"code": "M7", "name": "MasAir"},
     {"code": "M7", "name": "Marsland Aviation"},
     {"code": "M7", "name": "Tropical Airways"},
     {"code": "M8", "name": "Mekong Airlines"},
     {"code": "M9", "name": "Motor Sich"},
     {"code": "MA", "name": "Malév Hungarian Airlines"},
     {"code": "MB", "name": "Execair Aviation"},
     {"code": "MB", "name": "MNG Airlines"},
     {"code": "MC", "name": "Air Mobility Command"},
     {"code": "MD", "name": "Air Madagascar"},
     {"code": "ME", "name": "Middle East Airlines"},
     {"code": "MF", "name": "Xiamen Airlines"},
     {"code": "MG", "name": "Champion Air"},
     {"code": "MH", "name": "MASwings"},
     {"code": "MH", "name": "Malaysia Airlines"},
     {"code": "MI", "name": "SilkAir"},
     {"code": "MJ", "name": "Líneas Aéreas Privadas Argentinas"},
     {"code": "MJ", "name": "Mihin Lanka"},
     {"code": "MK", "name": "Air Mauritius"},
     {"code": "ML", "name": "Air Mediterranee"},
     {"code": "ML", "name": "African Transport Trading and Investment Company"},
     {"code": "ML", "name": "Midway Airlines (1976–1991)"},
     {"code": "MM", "name": "EuroAtlantic Airways"},
     {"code": "MM", "name": "SAM Colombia"},
     {"code": "MN", "name": "Comair"},
     {"code": "MO", "name": "Abu Dhabi Amiri Flight"},
     {"code": "MO", "name": "Calm Air"},
     {"code": "MP", "name": "Martinair"},
     {"code": "MQ", "name": "American Eagle Airlines"},
     {"code": "MQ", "name": "Envoy Air"},
     {"code": "MR", "name": "Air Mauritanie"},
     {"code": "MR", "name": "Hunnu Air"},
     {"code": "MS", "name": "Egyptair"},
     {"code": "MT", "name": "JMC Airlines"},
     {"code": "MT", "name": "Thomas Cook Airlines"},
     {"code": "MU", "name": "China Eastern Airlines"},
     {"code": "MV", "name": "Air Mediterranean"},
     {"code": "MW", "name": "Maya Island Air"},
     {"code": "MW", "name": "Mokulele Airlines"},
     {"code": "MX", "name": "Breeze_Airways"},
     {"code": "MX", "name": "Mexicana de Aviación"},
     {"code": "MY", "name": "Maxjet Airways"},
     {"code": "MY", "name": "Midwest Airlines (Egypt)"},
     {"code": "MZ", "name": "Merpati Nusantara Airlines"},
     {"code": "N/A", "name": "T3 Aviation, Inc."},
     {"code": "N/A", "name": "North Coast Air Services Ltd"},
     {"code": "N2", "name": "Dagestan Airlines"},
     {"code": "N2", "name": "Kabo Air"},
     {"code": "N4", "name": "Mountain Air Company"},
     {"code": "N4", "name": "National Airlines"},
     {"code": "N4", "name": "Nordwind Airlines"},
     {"code": "N5", "name": "Kyrgyz Airlines"},
     {"code": "N5", "name": "Fly Easy"},
     {"code": "N5", "name": "Norfolk Air"},
     {"code": "N5", "name": "Skagway Air Service"},
     {"code": "N6", "name": "Lagun Air"},
     {"code": "N6", "name": "Nuevo Continente"},
     {"code": "N7", "name": "National Airlines"},
     {"code": "N8", "name": "Fika Salaama Airlines"},
     {"code": "N8", "name": "National Air Cargo dba National Airlines"},
     {"code": "N9", "name": "North Coast Aviation"},
     {"code": "N9", "name": "Shree Airlines"},
     {"code": "NA", "name": "National Airlines"},
     {"code": "NA", "name": "North American Airlines"},
     {"code": "NB", "name": "Sterling Airlines"},
     {"code": "NC", "name": "National Jet Systems"},
     {"code": "NC", "name": "Northern Air Cargo"},
     {"code": "NE", "name": "SkyEurope"},
     {"code": "NF", "name": "Air Vanuatu"},
     {"code": "NG", "name": "Lauda Air"},
     {"code": "NH", "name": "All Nippon Airways"},
     {"code": "NI", "name": "LANICA"},
     {"code": "NI", "name": "Portugalia"},
     {"code": "NK", "name": "Spirit Airlines"},
     {"code": "NL", "name": "Shaheen Air"},
     {"code": "NM", "name": "Air Madrid"},
     {"code": "NM", "name": "Mount Cook Airline"},
     {"code": "NN", "name": "VIM Airlines"},
     {"code": "NO", "name": "Aus-Air"},
     {"code": "NO", "name": "Neos"},
     {"code": "NQ", "name": "Air Japan"},
     {"code": "NR", "name": "Pamir Airways"},
     {"code": "NT", "name": "Binter Canarias"},
     {"code": "NU", "name": "Japan Transocean Air"},
     {"code": "NV", "name": "Air Central"},
     {"code": "NW", "name": "Northwest Airlines"},
     {"code": "", "name": ""},
     {"code": "NX", "name": "Air Macau"},
     {"code": "NY", "name": "Air Iceland"},
     {"code": "NZ", "name": "Eagle Airways"},
     {"code": "NZ", "name": "Air New Zealand"},
     {"code": "TE", "name": ""},
     {"code": "O2", "name": "OLT Express"},
     {"code": "O2", "name": "Linear Air"},
     {"code": "O3", "name": "SF Airlines"},
     {"code": "O4", "name": "Antrak Air"},
     {"code": "O6", "name": "Avianca Brasil"},
     {"code": "O6", "name": "Avianca Brasil"},
     {"code": "O7", "name": "OzJet"},
     {"code": "O8", "name": "Oasis Hong Kong Airlines"},
     {"code": "O9", "name": "Nova Airline"},
     {"code": "OA", "name": "Olympic Air"},
     {"code": "OA", "name": "Olympic Airlines"},
     {"code": "OB", "name": "Astrakhan Airlines"},
     {"code": "OB", "name": "Austrian Airtransport"},
     {"code": "OB", "name": "Boliviana de Aviación"},
     {"code": "OB", "name": "Oasis International Airlines Now assigned to Boliviana de Aviacion (BoA)"},
     {"code": "OD", "name": "Malindo Airways"},
     {"code": "OE", "name": "Asia Overnight Express"},
     {"code": "OE[34]", "name": "LaudaMotion"},
     {"code": "OE", "name": "Laudamotion"},
     {"code": "OF", "name": "Air Finland"},
     {"code": "OF", "name": "Enter Air"},
     {"code": "OF", "name": "Transports et Travaux Aériens de Madagascar"},
     {"code": "OH", "name": "Comair"},
     {"code": "OH", "name": "PSA Airlines"},
     {"code": "OJ", "name": "Fly Jamaica Airways"},
     {"code": "OJ", "name": "Overland Airways"},
     {"code": "OK", "name": "Czech Airlines"},
     {"code": "OK", "name": "Czech Airlines"},
     {"code": "OL", "name": "OLT Express Germany"},
     {"code": "OL", "name": "Samoa Air"},
     {"code": "OM", "name": "MIAT Mongolian Airlines"},
     {"code": "ON", "name": "Our Airline"},
     {"code": "OO", "name": "SkyWest Airlines"},
     {"code": "OP", "name": "Chalk's International Airlines"},
     {"code": "OQ", "name": "Chongqing Airlines"},
     {"code": "OR", "name": "TUI fly Netherlands"},
     {"code": "OS", "name": "Austrian Airlines"},
     {"code": "OT", "name": "Aeropelican Air Services"},
     {"code": "OU", "name": "Croatia Airlines"},
     {"code": "OV", "name": "Estonian Air"},
     {"code": "OV", "name": "SalamAir"},
     {"code": "OW", "name": "Executive Airlines"},
     {"code": "OX", "name": "Orient Thai Airlines"},
     {"code": "OY", "name": "Andes Líneas Aéreas"},
     {"code": "OY", "name": "Omni Air International"},
     {"code": "OZ", "name": "Asiana Airlines"},
     {"code": "OZ", "name": "Ozark Air Lines"},
     {"code": "P0", "name": "Proflight Zambia"},
     {"code": "P2", "name": "Small Planet Airlines"},
     {"code": "P3", "name": "Cargo Logic Air"},
     {"code": "P3", "name": "Passaredo Transportes Aéreos"},
     {"code": "P5", "name": "AeroRepública"},
     {"code": "P6", "name": "Privilege Style Líneas Aéreas"},
     {"code": "P7", "name": "Regional Paraguaya"},
     {"code": "P7", "name": "Russian Sky Airlines"},
     {"code": "P7", "name": "Small Planet Airlines"},
     {"code": "P8", "name": "Air Mekong"},
     {"code": "P8", "name": "Pantanal Linhas Aéreas"},
     {"code": "P9", "name": "Nas Air"},
     {"code": "P9", "name": "Perm Airlines"},
     {"code": "P9", "name": "Peruvian Airlines"},
     {"code": "PA", "name": "Florida Coastal Airlines"},
     {"code": "PA", "name": "Pan American Airways"},
     {"code": "PA", "name": "Pan American World Airways"},
     {"code": "PB", "name": "Provincial Airlines"},
     {"code": "PC", "name": "Air Fiji"},
     {"code": "PC", "name": "Pegasus Airlines"},
     {"code": "PD", "name": "Porter Airlines"},
     {"code": "PE", "name": "Air Europe Italy"},
     {"code": "PE", "name": "People's"},
     {"code": "PF", "name": "Palestinian Airlines"},
     {"code": "PG", "name": "Bangkok Airways"},
     {"code": "PH", "name": "Polynesian Airlines"},
     {"code": "PI", "name": "Piedmont Airlines (1948-1989)"},
     {"code": "PI", "name": "Sol del Paraguay"},
     {"code": "PI", "name": "Sun Air (Fiji)"},
     {"code": "PJ", "name": "Air Saint Pierre"},
     {"code": "PK", "name": "Pakistan International Airlines"},
     {"code": "PL", "name": "Aeroperú"},
     {"code": "PL", "name": "Airstars"},
     {"code": "PM", "name": "Tropic Air"},
     {"code": "PN", "name": "West Air (China)"},
     {"code": "PN", "name": "Pan American Airways"},
     {"code": "PO", "name": "Polar Air Cargo"},
     {"code": "PP", "name": "Jet Aviation"},
     {"code": "PQ", "name": "SkyUp"},
     {"code": "PR", "name": "Philippine Airlines"},
     {"code": "PS", "name": "Ukraine International Airlines"},
     {"code": "PT", "name": "Capital Cargo International Airlines"},
     {"code": "PT", "name": "West Air Sweden"},
     {"code": "PU", "name": "PLUNA"},
     {"code": "PV", "name": "PAN Air"},
     {"code": "PV", "name": "St Barth Commuter"},
     {"code": "PW", "name": "Precision Air"},
     {"code": "PX", "name": "Air Niugini"},
     {"code": "PY", "name": "Surinam Airways"},
     {"code": "PZ", "name": "LATAM Paraguay"},
     {"code": "PZ", "name": "TAM Mercosur"},
     {"code": "Q2", "name": "Maldivian (airline)"},
     {"code": "Q3", "name": "Zambian Airways"},
     {"code": "Q4", "name": "Mastertop Linhas Aéreas"},
     {"code": "Q4", "name": "Swazi Express Airways"},
     {"code": "Q4", "name": "Starlink Aviation"},
     {"code": "Q5", "name": "40-Mile Air"},
     {"code": "Q6", "name": "Aero Condor Peru"},
     {"code": "Q7", "name": "SkyBahamas"},
     {"code": "Q8", "name": "Pacific East Asia Cargo Airlines"},
     {"code": "Q9", "name": "Afrinat International Airlines"},
     {"code": "QB", "name": "Air Alma"},
     {"code": "QB", "name": "Georgian National Airlines"},
     {"code": "QC", "name": "Air Corridor"},
     {"code": "QD", "name": "Air Class Líneas Aéreas"},
     {"code": "QE", "name": "Crossair Europe"},
     {"code": "QF", "name": "Eastern Australia Airlines"},
     {"code": "QF", "name": "Qantas"},
     {"code": "QF", "name": "QantasLink"},
     {"code": "QF", "name": "QantasLink"},
     {"code": "QF", "name": "Sunstate Airlines"},
     {"code": "QH", "name": "Air Kyrgyzstan"},
     {"code": "QH", "name": "Aero Leasing"},
     {"code": "QH", "name": "Air Florida"},
     {"code": "QH", "name": "Kyrgyzstan"},
     {"code": "QI", "name": "Cimber Sterling"},
     {"code": "QJ", "name": "Jet Airways"},
     {"code": "QK", "name": "Air Canada Jazz"},
     {"code": "QL", "name": "Aero Lanka"},
     {"code": "QL", "name": "Lankan Cargo"},
     {"code": "QL", "name": "Línea Aérea de Servicio Ejecutivo Regional"},
     {"code": "QM", "name": "Air Malawi"},
     {"code": "QN", "name": "Air Armenia"},
     {"code": "QO", "name": "Aeromexpress"},
     {"code": "QO", "name": "Origin Pacific Airways"},
     {"code": "QQ", "name": "Alliance Airlines"},
     {"code": "QQ", "name": "Reno Air"},
     {"code": "QR", "name": "Qatar Airways"},
     {"code": "QS", "name": "African Safari Airways"},
     {"code": "QS", "name": "Smartwings"},
     {"code": "QT", "name": "TAMPA"},
     {"code": "QU", "name": "UTair-Ukraine"},
     {"code": "QU", "name": "Uganda Airlines (1976–2001)"},
     {"code": "QV", "name": "Lao Airlines"},
     {"code": "QW", "name": "Blue Wings"},
     {"code": "QX", "name": "Horizon Air"},
     {"code": "QY", "name": "European Air Transport"},
     {"code": "QZ", "name": "Indonesia AirAsia"},
     {"code": "R0", "name": "Royal Airlines"},
     {"code": "R1", "name": "Sirin"},
     {"code": "R2", "name": "Orenburg Airlines"},
     {"code": "R3", "name": "Armenian Airlines"},
     {"code": "R3", "name": "Aircompany Yakutia"},
     {"code": "R3", "name": "Yakutia Airlines"},
     {"code": "R5", "name": "Jordan Aviation"},
     {"code": "R5", "name": "Malta Air Charter"},
     {"code": "R6", "name": "RACSA"},
     {"code": "R7", "name": "Aserca Airlines"},
     {"code": "R8", "name": "Kyrgyzstan Airlines"},
     {"code": "R9", "name": "Camai Air"},
     {"code": "RA", "name": "Nepal Airlines"},
     {"code": "RB", "name": "Air Srpska"},
     {"code": "RB", "name": "Syrian Arab Airlines"},
     {"code": "RC", "name": "Atlantic Airways"},
     {"code": "RC", "name": "Republic Airlines"},
     {"code": "RD", "name": "Ryan International Airlines"},
     {"code": "RE", "name": "Aer Arann"},
     {"code": "RE", "name": "Stobart Air"},
     {"code": "RF", "name": "Florida West International Airways"},
     {"code": "RG", "name": "Varig"},
     {"code": "RH", "name": "Hong Kong Air Cargo"},
     {"code": "RH", "name": "Republic Express Airlines"},
     {"code": "RI", "name": "Mandala Airlines"},
     {"code": "RJ", "name": "Royal Jordanian"},
     {"code": "RK", "name": "Skyview Airways"},
     {"code": "RK", "name": "Royal Khmer Airlines"},
     {"code": "RK", "name": "Ryanair UK"},
     {"code": "RL", "name": "Rio Linhas Aéreas"},
     {"code": "RL", "name": "Royal Phnom Penh Airways"},
     {"code": "RO", "name": "Tarom"},
     {"code": "RP*", "name": "Chautauqua Airlines"},
     {"code": "RQ", "name": "Kam Air"},
     {"code": "RR", "name": "Royal Air Force"},
     {"code": "RR", "name": "Buzz (Ryanair)"},
     {"code": "RS", "name": "Air Seoul"},
     {"code": "RS", "name": "Intercontinental de Aviación"},
     {"code": "RS", "name": "Royal Air Force of Oman"},
     {"code": "RT", "name": "UVT Aero"},
     {"code": "RU", "name": "AirBridge Cargo"},
     {"code": "RU", "name": "SkyKing Turks and Caicos Airways"},
     {"code": "RV", "name": "Air Canada Rouge"},
     {"code": "RV", "name": "Caspian Airlines"},
     {"code": "RV*", "name": "Africaone"},
     {"code": "RW", "name": "Republic Airways"},
     {"code": "RX", "name": "Aviaexpress"},
     {"code": "RX", "name": "Regent Airways"},
     {"code": "RZ", "name": "Euro Exec Express"},
     {"code": "RZ*", "name": "Sansa"},
     {"code": "S0", "name": "Slok Air Gambia"},
     {"code": "S2", "name": "Air Sahara"},
     {"code": "S3", "name": "Santa Barbara Airlines"},
     {"code": "S4", "name": "SATA International"},
     {"code": "S5", "name": "Star Air (India)"},
     {"code": "S5", "name": "Shuttle America"},
     {"code": "S5", "name": "Small Planet Airlines"},
     {"code": "S5", "name": "Trast Aero"},
     {"code": "S6", "name": "Star Air"},
     {"code": "S6", "name": "Star Air"},
     {"code": "S7", "name": "S7 Airlines"},
     {"code": "S8", "name": "Chari Aviation Services"},
     {"code": "S8", "name": "Shovkoviy Shlyah"},
     {"code": "S8", "name": "Skywise Airline"},
     {"code": "S9", "name": "East African Safari Air"},
     {"code": "SA", "name": "South African Airways"},
     {"code": "SB", "name": "Air Caledonie International"},
     {"code": "SC", "name": "Shandong Airlines"},
     {"code": "SD", "name": "Sudan Airways"},
     {"code": "SE", "name": "XL Airways France"},
     {"code": "SF", "name": "Tassili Airlines"},
     {"code": "SG", "name": "JetsGo"},
     {"code": "SG", "name": "Spicejet"},
     {"code": "SH", "name": "Fly Me Sweden"},
     {"code": "SH", "name": "Sharp Airlines"},
     {"code": "SI", "name": "Blue Islands"},
     {"code": "SI", "name": "Skynet Airlines"},
     {"code": "SJ", "name": "Freedom Air"},
     {"code": "SK", "name": "Scandinavian Airlines"},
     {"code": "SK", "name": "SAS Braathens"},
     {"code": "SL", "name": "Rio Sul Serviços Aéreos Regionais"},
     {"code": "SL", "name": "Thai Lion Mentari"},
     {"code": "SM", "name": "Aberdeen Airways"},
     {"code": "SM", "name": "Swedline Express"},
     {"code": "SN", "name": "Brussels International Airlines"},
     {"code": "SN", "name": "Brussels Airlines"},
     {"code": "SO", "name": "Superior Aviation"},
     {"code": "SO", "name": "Sosoliso Airlines"},
     {"code": "SO", "name": "Sunshine Airlines"},
     {"code": "SP", "name": "SATA Air Acores"},
     {"code": "SQ", "name": "Singapore Airlines"},
     {"code": "SQ", "name": "Singapore Airlines Cargo"},
     {"code": "SR", "name": "Swissair"},
     {"code": "SR", "name": "Sundair"},
     {"code": "SS", "name": "Corsairfly"},
     {"code": "SS", "name": "Corsairfly"},
     {"code": "ST", "name": "Germania"},
     {"code": "ST*", "name": "Western Aircraft, Inc"},
     {"code": "SU", "name": "Aeroflot Russian Airlines"},
     {"code": "SV", "name": "Saudia"},
     {"code": "SW", "name": "Air Namibia"},
     {"code": "SX", "name": "FlyGTA Airlines"},
     {"code": "SX", "name": "Sky Work Airlines"},
     {"code": "SX", "name": "Skybus Airlines"},
     {"code": "SY", "name": "Sun Country Airlines"},
     {"code": "SZ", "name": "Air Southwest"},
     {"code": "T2", "name": "Thai Air Cargo"},
     {"code": "T3", "name": "Eastern Airways"},
     {"code": "T4", "name": "TRIP Linhas Aéreas"},
     {"code": "T5", "name": "Turkmenhovayollary"},
     {"code": "T6", "name": "Tavrey Airlines"},
     {"code": "T7", "name": "Twin Jet"},
     {"code": "T9", "name": "Thai Star Airlines"},
     {"code": "T9", "name": "TransMeridian Airlines"},
     {"code": "TA", "name": "Avianca El Salvador"},
     {"code": "TB", "name": "TUI fly Belgium"},
     {"code": "TC", "name": "Air Tanzania"},
     {"code": "TC", "name": "Air Tanzania Company Limited"},
     {"code": "TD", "name": "Atlantis European Airways"},
     {"code": "TD", "name": "Tulip Air"},
     {"code": "TE", "name": "FlyLal"},
     {"code": "TE", "name": "Skytaxi"},
     {"code": "TF", "name": "Malmö Aviation"},
     {"code": "TG", "name": "Thai Airways International"},
     {"code": "TH", "name": "BA Connect"},
     {"code": "TH", "name": "Transmile Air Services"},
     {"code": "TI", "name": "Tailwind Airlines"},
     {"code": "TI", "name": "Tol-Air Services"},
     {"code": "TJ", "name": "Tradewind Aviation"},
     {"code": "TK", "name": "Turkish Airlines"},
     {"code": "TL", "name": "Airnorth"},
     {"code": "TL", "name": "Trans Mediterranean Airlines"},
     {"code": "TM", "name": "Linhas Aéreas de Moçambique"},
     {"code": "TN", "name": "Air Tahiti Nui"},
     {"code": "TO", "name": "President Airlines"},
     {"code": "TO", "name": "Transavia France"},
     {"code": "TP", "name": "TAP Portugal"},
     {"code": "TQ", "name": "Tandem Aero"},
     {"code": "TR", "name": "Scoot"},
     {"code": "TR", "name": "Tigerair Singapore"},
     {"code": "TR", "name": "Transbrasil"},
     {"code": "TS", "name": "Air Transat"},
     {"code": "TT", "name": "Air Lithuania"},
     {"code": "TT", "name": "Tigerair Australia"},
     {"code": "TU", "name": "Tunisair"},
     {"code": "TV", "name": "Virgin Express"},
     {"code": "TW", "name": "Trans World Airlines"},
     {"code": "TW", "name": "T'way Air"},
     {"code": "TX", "name": "Air Caraïbes"},
     {"code": "TX", "name": "Transportes Aéreos Nacionales"},
     {"code": "TXZ", "name": "Thai Express Air"},
     {"code": "TY", "name": "Air Calédonie"},
     {"code": "TY", "name": "Iberworld"},
     {"code": "TZ", "name": "air-taxi Europe"},
     {"code": "TZ", "name": "ATA Airlines"},
     {"code": "TZ", "name": "Tsaradia"},
     {"code": "U2", "name": "easyJet UK"},
     {"code": "U3", "name": "Avies"},
     {"code": "U4", "name": "Buddha Air"},
     {"code": "U4", "name": "PMTair"},
     {"code": "U5", "name": "USA3000 Airlines"},
     {"code": "U6", "name": "Ural Airlines"},
     {"code": "U7", "name": "Air Uganda"},
     {"code": "U7", "name": "Northern Dene Airways"},
     {"code": "U7", "name": "USA Jet Airlines"},
     {"code": "U8", "name": "Armavia"},
     {"code": "UA", "name": "United Airlines"},
     {"code": "UB", "name": "Myanma Airways"},
     {"code": "UC", "name": "LATAM Cargo Chile"},
     {"code": "UD", "name": "Hex'Air"},
     {"code": "UE", "name": "Nasair"},
     {"code": "UE", "name": "Transeuropean Airlines"},
     {"code": "UF", "name": "UM Airlines"},
     {"code": "UG", "name": "SevenAir"},
     {"code": "UG", "name": "Tuninter"},
     {"code": "UH", "name": "US Helicopter"},
     {"code": "UI", "name": "Eurocypria Airlines"},
     {"code": "UI", "name": "SW Italia"},
     {"code": "UJ", "name": "Al Masria Universal Airlines"},
     {"code": "UK", "name": "Vistara"},
     {"code": "UL", "name": "SriLankan Airlines"},
     {"code": "UM", "name": "Air Zimbabwe"},
     {"code": "UN", "name": "Transaero Airlines"},
     {"code": "UO", "name": "Hong Kong Express Airways"},
     {"code": "UP", "name": "Bahamasair"},
     {"code": "UQ", "name": "O'Connor Airlines"},
     {"code": "UR", "name": "Uganda Airlines"},
     {"code": "US", "name": "US Airways"},
     {"code": "US", "name": "Unavia Suisse"},
     {"code": "UT", "name": "UTair Aviation"},
     {"code": "UU", "name": "Air Austral"},
     {"code": "UX", "name": "Air Europa"},
     {"code": "UY", "name": "Cameroon Airlines"},
     {"code": "UZ", "name": "El-Buraq Air Transport"},
     {"code": "V0", "name": "Conviasa"},
     {"code": "V2", "name": "Karat"},
     {"code": "V2", "name": "Vision Airlines"},
     {"code": "V3", "name": "Carpatair"},
     {"code": "V4", "name": "Reem Air"},
     {"code": "V4", "name": "Vieques Air Link"},
     {"code": "V5", "name": "Avolar Aerolíneas"},
     {"code": "V5", "name": "DanubeWings"},
     {"code": "V5", "name": "Royal Aruban Airlines"},
     {"code": "V7", "name": "Air Senegal International"},
     {"code": "V7", "name": "Volotea"},
     {"code": "V8", "name": "ATRAN Cargo Airlines"},
     {"code": "V8", "name": "Iliamna Air Taxi"},
     {"code": "V9", "name": "BAL Bashkirian Airlines"},
     {"code": "V9", "name": "Star1 Airlines"},
     {"code": "VA", "name": "Virgin Australia Regional Airlines"},
     {"code": "VA", "name": "Virgin Australia"},
     {"code": "VA", "name": "Viasa"},
     {"code": "VB", "name": "Aeroenlaces Nacionales"},
     {"code": "VB", "name": "Maersk Air UK"},
     {"code": "VB", "name": "VivaAerobus"},
     {"code": "VC", "name": "Ocean Airlines"},
     {"code": "VC", "name": "Voyageur Airways"},
     {"code": "VD", "name": "Air Liberté"},
     {"code": "VD", "name": "Kunpeng Airlines"},
     {"code": "VD", "name": "SwedJet Airways"},
     {"code": "VE", "name": "Avensa"},
     {"code": "VE", "name": "EUjet"},
     {"code": "VE", "name": "C.A.I. Second"},
     {"code": "VF", "name": "Valuair"},
     {"code": "VG", "name": "VLM Airlines"},
     {"code": "VH", "name": "Aeropostal Alas de Venezuela"},
     {"code": "VH", "name": "Viva Air Colombia"},
     {"code": "VI", "name": "Volga-Dnepr Airlines"},
     {"code": "VJ", "name": "Africa Airways"},
     {"code": "VJ", "name": "Jatayu Airlines"},
     {"code": "VJ", "name": "Vietjet Air"},
     {"code": "VK", "name": "FlyViking"},
     {"code": "VK", "name": "Virgin Nigeria Airways"},
     {"code": "VL", "name": "Air VIA"},
     {"code": "VM", "name": "His Majesty King Maha Vajiralongkorn"},
     {"code": "VM", "name": "Viaggio Air"},
     {"code": "VN", "name": "Vietnam Airlines"},
     {"code": "VO", "name": "Tyrolean Airways"},
     {"code": "VP", "name": "VASP"},
     {"code": "VQ", "name": "Novo Air"},
     {"code": "VR", "name": "TACV"},
     {"code": "VS", "name": "Virgin Atlantic"},
     {"code": "VT", "name": "Air Tahiti"},
     {"code": "VU", "name": "Air Ivoire"},
     {"code": "VU", "name": "Vietravel Airlines"},
     {"code": "VV", "name": "Aerosvit Airlines"},
     {"code": "VW", "name": "Aeromar"},
     {"code": "VX", "name": "ACES Colombia"},
     {"code": "VX", "name": "Virgin America"},
     {"code": "VY", "name": "Formosa Airlines"},
     {"code": "VY", "name": "Vueling Airlines"},
     {"code": "VZ", "name": "MyTravel Airways"},
     {"code": "VZ", "name": "Thai Vietjet Air"},
     {"code": "W2", "name": "Canadian Western Airlines"},
     {"code": "W3", "name": "Flyhy Cargo Airlines"},
     {"code": "W3", "name": "Switfair Cargo"},
     {"code": "W4", "name": "Aero Services Executive"},
     {"code": "W5", "name": "Mahan Air"},
     {"code": "W6", "name": "Wizz Air"},
     {"code": "W7", "name": "Sayakhat Airlines"},
     {"code": "W7", "name": "Western Pacific Airlines"},
     {"code": "W8", "name": "Cargojet Airways"},
     {"code": "W9", "name": "Abelag Aviation"},
     {"code": "W9", "name": "Air Bagan"},
     {"code": "W9", "name": "Eastwind Airlines"},
     {"code": "W9", "name": "Wizz Air UK"},
     {"code": "WA", "name": "KLM Cityhopper"},
     {"code": "WA", "name": "Western Airlines"},
     {"code": "WA", "name": "KLM Cityhopper"},
     {"code": "WB", "name": "Rwandair Express"},
     {"code": "WC", "name": "Islena De Inversiones"},
     {"code": "WD", "name": "DAS Air Cargo"},
     {"code": "WD", "name": "Modern Transporte Aereo De Carga"},
     {"code": "WD", "name": "WDL Aviation"},
     {"code": "WD*", "name": "Amsterdam Airlines"},
     {"code": "WE", "name": "Centurion Air Cargo"},
     {"code": "WE", "name": "Thai Smile Airways"},
     {"code": "WF", "name": "Widerøe"},
     {"code": "WG", "name": "Sunwing Airlines"},
     {"code": "WH", "name": "China Northwest Airlines"},
     {"code": "WH", "name": "WebJet Linhas Aéreas"},
     {"code": "WI", "name": "Aero Air"},
     {"code": "WK", "name": "American Falcon"},
     {"code": "WK", "name": "Edelweiss Air"},
     {"code": "WL", "name": "Air Wales Virtual"},
     {"code": "WN", "name": "Southwest Airlines"},
     {"code": "WO", "name": "Swoop"},
     {"code": "WO", "name": "World Airways"},
     {"code": "WP", "name": "Air Antwerp"},
     {"code": "WQ", "name": "Swift Air (Interstate Equipment Leasing)"},
     {"code": "WR", "name": "Royal Tongan Airlines"},
     {"code": "WR", "name": "WestJet Encore"},
     {"code": "WS", "name": "WestJet"},
     {"code": "WT", "name": "Wasaya Airways"},
     {"code": "WV", "name": "Swe Fly"},
     {"code": "WW", "name": "Bmibaby"},
     {"code": "WW", "name": "WOW air"},
     {"code": "WX", "name": "CityJet"},
     {"code": "WX", "name": "CityJet"},
     {"code": "WY", "name": "Oman Air"},
     {"code": "WZ", "name": "West African Airlines"},
     {"code": "X3", "name": "Hapag-Lloyd Express"},
     {"code": "X3", "name": "TUI fly Deutschland"},
     {"code": "X7", "name": "Chitaavia"},
     {"code": "X9", "name": "Avion Express"},
     {"code": "XC", "name": "Corendon Airlines"},
     {"code": "XE", "name": "JSX (airline)"},
     {"code": "XF", "name": "Vladivostok Air"},
     {"code": "XG", "name": "Clickair"},
     {"code": "XG", "name": "Sunexpress Deutschland"},
     {"code": "XJ", "name": "Mesaba Airlines"},
     {"code": "XJ", "name": "Thai AirAsia X"},
     {"code": "XK", "name": "Air Corsica"},
     {"code": "XK", "name": "Corse Méditerranée"},
     {"code": "XL", "name": "Aerolane"},
     {"code": "XM", "name": "J-Air"},
     {"code": "XN", "name": "XpressAir"},
     {"code": "XO", "name": "China Xinhua Airlines"},
     {"code": "XO", "name": "LTE International Airways"},
     {"code": "XP", "name": "Xtra Airways"},
     {"code": "XQ", "name": "SunExpress"},
     {"code": "XS", "name": "SITA"},
     {"code": "XT", "name": "Air Exel"},
     {"code": "XT", "name": "SkyStar Airways"},
     {"code": "XW", "name": "NokScoot"},
     {"code": "XY", "name": "Flynas"},
     {"code": "Y0", "name": "Yellow Air Taxi/Friendship Airways"},
     {"code": "Y2", "name": "Alliance Air"},
     {"code": "Y2", "name": "Flyglobespan"},
     {"code": "Y4", "name": "Volaris"},
     {"code": "Y5", "name": "Golden Myanmar Airlines"},
     {"code": "Y5", "name": "Pace Airlines"},
     {"code": "Y6", "name": "Batavia Air"},
     {"code": "Y7", "name": "NordStar"},
     {"code": "Y8", "name": "Yangtze River Express"},
     {"code": "Y9", "name": "Lynx Air"},
     {"code": "YB", "name": "Borajet"},
     {"code": "YD", "name": "Cologne Air Transport GmbH"},
     {"code": "YE", "name": "Aryan Cargo Express"},
     {"code": "YH", "name": "West Caribbean Airways"},
     {"code": "YI", "name": "Air Sunshine"},
     {"code": "YK", "name": "Cyprus Turkish Airlines"},
     {"code": "YL", "name": "Yamal Airlines"},
     {"code": "YM", "name": "Montenegro Airlines"},
     {"code": "YQ", "name": "TAR Aerolineas"},
     {"code": "YS", "name": "Régional Compagnie Aérienne Européenne"},
     {"code": "YT", "name": "Air Togo"},
     {"code": "YT", "name": "Yeti Airlines"},
     {"code": "YU", "name": "Dominair"},
     {"code": "YV", "name": "Mesa Airlines"},
     {"code": "YW", "name": "Air Nostrum"},
     {"code": "YX", "name": "Midwest Airlines"},
     {"code": "Z2", "name": "Philippines AirAsia"},
     {"code": "Z3", "name": "Avient Aviation"},
     {"code": "Z4", "name": "Zoom Airlines"},
     {"code": "Z5", "name": "GMG Airlines"},
     {"code": "Z6", "name": "Dniproavia"},
     {"code": "Z7*", "name": "ADC Airlines"},
     {"code": "Z8", "name": "Línea Aérea Amaszonas"},
     {"code": "ZA", "name": "AccessAir"},
     {"code": "ZA", "name": "Interavia Airlines"},
     {"code": "ZB", "name": "Air Bourbon"},
     {"code": "ZB", "name": "Air Albania"},
     {"code": "ZB", "name": "Monarch Airlines"},
     {"code": "ZD", "name": "Ewa Air"},
     {"code": "ZE", "name": "Arcus-Air Logistic"},
     {"code": "ZE", "name": "Eastar Jet"},
     {"code": "ZE", "name": "Líneas Aéreas Azteca"},
     {"code": "ZG", "name": "Viva Macau"},
     {"code": "ZG", "name": "ZIPAIR Tokyo"},
     {"code": "ZH", "name": "Shenzhen Airlines"},
     {"code": "ZI", "name": "Aigle Azur"},
     {"code": "ZK", "name": "Great Lakes Airlines"},
     {"code": "ZL", "name": "Regional Express"},
     {"code": "ZP", "name": "Amaszonas Paraguay"},
     {"code": "ZP", "name": "Silk Way Airlines"},
     {"code": "ZS", "name": "Azzurra Air"},
     {"code": "ZS", "name": "Sama Airlines"},
     {"code": "ZT", "name": "Titan Airways"},
     {"code": "ZT", "name": "Titan Airways"},
     {"code": "ZU", "name": "Helios Airways"},
     {"code": "ZV", "name": "Air Midwest"},
     {"code": "ZW", "name": "Air Wisconsin"},
     {"code": "ZX", "name": "Air BC"},
     {"code": "ZX", "name": "Air Georgian"},
     {"code": "ZY", "name": "Sky Airlines"}
     

];

export default airlines;